import { styled } from "@mui/material";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import Color from "color";
import CoverProductCard from "./CoverProductCard";
import NameProductCard from "./NameProductCard";
import PriceProductCard from "./PriceProductCard";
import DescriptionProductCard from "./DescriptionProductCard";
import BuyBtnProductCard from "./BuyBtnProductCard";
import StockProductCard from "./StockProductCard";
import ButtonMenuSettings from "../../Button/ButtonMenuSettings";
import { useLocation, useNavigate } from "react-router";

const RootCardProduit = styled("div")(
	({ theme, color = theme.palette.primary.dark }) => ({
		position: "relative",
		borderRadius: "1rem",
		cursor: "pointer",
		//minWidth: 258,
		paddingTop: "50%",
		"&:before": {
			transition: "0.2s",
			position: "absolute",
			width: "100%",
			height: "100%",
			content: '""',
			display: "block",
			borderRadius: "1rem",
			zIndex: 0,
			bottom: 0,
			backgroundColor: Color(color).darken(0.3).desaturate(0.2).string(),
			boxShadow: `0 6px 16px 0 ${Color(color).fade(0.5)}`,
		},
		"&:hover": {
			"&:before": {
				bottom: -6,
			},
			"& .MuiAvatar-root": {
				transform: "scale(1.1)",
				boxShadow: "0 6px 20px 0 rgba(0,0,0,0.38)",
			},
			"& > div": {
				"&:before": {
					top: -20,
					height: "125%",
				},
			},
		},
	})
);

const ContentCardProduit = styled("div")(
	({ theme, color = theme.palette.primary.dark }) => ({
		position: "relative",
		zIndex: -1,
		padding: "1rem",
		transition: "0.2s",
		borderRadius: "1rem",

		"&:before": {
			content: '""',
			transition: "0.2s",
			opacity: 0.8,
			display: "block",
			position: "absolute",
			left: 0,
			top: 1,
			zIndex: 0,
			width: "100%",
			height: "100%",
			clipPath:
				"polygon(0% 100%, 0% 35%, 0.3% 33%, 1% 31%, 1.5% 30%, 2% 29%, 2.5% 28.4%, 3% 27.9%, 3.3% 27.6%, 5% 27%,95% 0%,100% 0%, 100% 100%)",
			borderRadius: "1rem",
			background: `linear-gradient(to top, ${color}, ${Color(color)
				.rotate(24)
				.lighten(0.12)})`,
		},
	})
);

export default function ProductCard({
	id,
	cover,
	prix,
	name,
	categorie,
	unite,
	stock,
	isOpen,
}) {
	const navigate = useNavigate();
	const location = useLocation().pathname;

	return (
		<RootCardProduit
			onClick={() =>
				!location.includes("gestion") && isOpen
					? navigate("./ajouter_commande/" + id)
					: null
			}
		>
			<CoverProductCard
				id={id}
				cover={cover}
			/>
			{location.includes("gestion/produits") && (
				<Box sx={{ position: "absolute", zIndex: 2, top: 1, right: 1 }}>
					<ButtonMenuSettings
						type={"produit"}
						id={id}
						color="info"
					/>
				</Box>
			)}

			<Grid
				container
				size={12}
				zIndex={1}
				component={ContentCardProduit}
				position={"relative"}
				justifyContent="space-between"
			>
				<Grid
					component={NameProductCard}
					size={12}
				>
					{name}
				</Grid>
				<Grid
					container
					columnSpacing={1}
					size={9}
				>
					<Grid
						size={4}
						component={PriceProductCard}
					>
						{prix.replace(".", "€")} kg
					</Grid>
					<Grid
						size={2}
						component={DescriptionProductCard}
					>
						{categorie + " - " + unite}
					</Grid>

					<Grid
						size={9}
						component={StockProductCard}
						id={id}
						stock={stock}
						unite={unite}
					/>
				</Grid>
				<Grid
					size={3}
					container
					justifyContent="flex-end"
				>
					<BuyBtnProductCard
						id={id}
						isOpen={isOpen}
					/>
				</Grid>
			</Grid>
		</RootCardProduit>
	);
}
